var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.address
    ? _c(
        "div",
        {
          staticClass: "address",
          class: { selected: _vm.selected },
          on: {
            click: function($event) {
              _vm.$emit("selected", _vm.address)
            }
          }
        },
        [
          _c("div", { staticClass: "title-address" }, [
            _vm._v(_vm._s(_vm.address.name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-5" }, [
            _c("i", [_vm._v(_vm._s(_vm.address.zip_code))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm._f("fullAddress")(_vm.address)))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "buttons-address" }, [
            _c(
              "div",
              {
                staticClass: "btn btn-small btn-rounded bg-purple-outline",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.edit($event)
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "mr-5",
                  attrs: { src: "/static/icon-edit.svg", height: "12px" }
                }),
                _vm._v(" editar\n    ")
              ]
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c06c2688", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c06c2688","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Addresses/Address.vue
// module id = null
// module chunks = 